(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['torso/modules/View', 'templates', 'services/insurancePolicyDetailsExtService'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    var templates = {
          insuranceCardModalTemplate: require('./insuranceCardModalTemplate.hbs')
        };
        module.exports = factory(require('backbone-torso/modules/View'), templates, require('./../urls').insurancePolicyDetailsExtService);
    } else {
      throw 'Only AMD and CommonJS imports are supported.';
    }
  }(this, function (TorsoView, templates, insurancePolicyDetailsExtService) {
  'use strict';

  var INSURANCE_CARD_SIDES = {
        BACK: 'BACK',
        FRONT: 'FRONT'
      };

  /**
   * View for insurance card images.
   *
   * @class InsuranceCardModalView
   * @constructor
   * @param options {Object}
   *   @param options.side {String} either 'FRONT' or 'BACK' to identify which insurance card image to show.
   *   @param options.insurancePolicyDetailsVecnaId {String} the vecna id of the insurance policy details that the card is associated with.
   */
  var InsuranceCardModalView = TorsoView.extend({
    className: 'portal-container portal-container--insurance-card-image',
    template: templates.insuranceCardModalTemplate,

    INSURANCE_CARD_SIDES: INSURANCE_CARD_SIDES,

    /**
     * @method initialize
     * @param options {Object}
     *   @param options.side {String} either 'FRONT' or 'BACK' to identify which insurance card image to show.
     *   @param options.insurancePolicyDetailsVecnaId {String} the vecna id of the insurance policy details that the card is associated with.
     * @override
     */
    initialize: function(options) {
      this._side = options.side;
      this._insurancePolicyDetailsVecnaId = options.insurancePolicyDetailsVecnaId;
    },

    /**
     * @method prepare
     * @override
     */
    prepare: function() {
      var templateContext = TorsoView.prototype.prepare.apply(this);
      templateContext.side = this._side;
      templateContext.insurancePolicyDetailsVecnaId = this._insurancePolicyDetailsVecnaId;
      templateContext.insurancePolicyDetailsExtService = insurancePolicyDetailsExtService;
      return templateContext;
    }
  });

  InsuranceCardModalView.INSURANCE_CARD_SIDES = INSURANCE_CARD_SIDES;
  return InsuranceCardModalView;
}));
